<template>
  <div class="width-limited-content">
    <div class="width-limited-content__inner-content">
      {{yield}}
    </div>
  </div>
</template>
